var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaseo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2937",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 30.25C24.7655 30.25 30.25 24.7655 30.25 18C30.25 11.2345 24.7655 5.75 18 5.75C11.2345 5.75 5.75 11.2345 5.75 18C5.75 24.7655 11.2345 30.25 18 30.25ZM18 32C25.732 32 32 25.732 32 18C32 10.268 25.732 4 18 4C10.268 4 4 10.268 4 18C4 25.732 10.268 32 18 32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2937",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78249 18.601C10.5916 20.1494 13.4001 21.61 16.7894 22.5182C20.1788 23.4263 23.3412 23.5657 25.6822 23.1293C28.1628 22.6669 29.1062 21.715 29.291 21.0254C29.4758 20.3359 29.1346 19.0399 27.2176 17.3991C25.4085 15.8506 22.6 14.3901 19.2107 13.4819C15.8214 12.5738 12.6589 12.4344 10.3179 12.8708C7.83731 13.3332 6.89386 14.2851 6.70909 14.9746C6.52432 15.6642 6.86546 16.9602 8.78249 18.601ZM5.01872 14.5217C4.09997 17.9506 9.16709 22.2875 16.3365 24.2085C23.5059 26.1295 30.0626 24.9072 30.9814 21.4784C31.9001 18.0495 26.833 13.7126 19.6636 11.7916C12.4942 9.87055 5.93747 11.0929 5.01872 14.5217Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2937",
    d: "M24.1872 15.5251C23.1621 16.5502 21.5 16.5502 20.4749 15.5251C19.4498 14.5 19.4498 12.8379 20.4749 11.8128C21.5 10.7877 23.1621 10.7877 24.1872 11.8128C25.2124 12.8379 25.2124 14.5 24.1872 15.5251Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2937",
    d: "M13.9782 23.259C12.9531 24.2841 11.291 24.2841 10.2659 23.259C9.24079 22.2338 9.24079 20.5718 10.2659 19.5467C11.291 18.5216 12.9531 18.5216 13.9782 19.5467C15.0033 20.5718 15.0033 22.2338 13.9782 23.259Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaseo);
export default __webpack_public_path__ + "static/media/paseo.c14c7e0e154418a0b609749868baa9a8.svg";
export { ForwardRef as ReactComponent };